import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";
class ArticleBrow extends Component {
  constructor(...props) {
    super(...props);
    this.state = {};
  }
  render() {
    const { title, href } = this.props;
    return (
      <div className="articleBrow_box">
        <div className="articleBrow_box_padding fl"></div>
        <div className="articleBrow_box_left fl">
          <div className="articleBrow_circle fl"></div>
          <div style={{ width: "5%", height: 42 }} className="fl"></div>
          <div className="fl">{title}</div>
          <div className="clear"></div>
        </div>
        <div className="articleBrow_box_right fl">
          <NavLink
            style={{ textDecoration: "none", color: "#7d7d7d" }}
            to={href}
            className="fr"
          >
            更多 <img alt="" src={require('../../../../../images/article/more.png')}></img>
          </NavLink>
        </div>
        <div className="articleBrow_box_padding fl"></div>
        <div className="clear"></div>
      </div>
    );
  }
}

export default ArticleBrow;



// WEBPACK FOOTER //
// ./src/containers/Home/components/Article/ArticleBrow/index.js